import type { Children } from '../../types';

import * as React from 'react';
import { useEditorHandlers } from './@editor';
import styled from '@emotion/styled';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

export interface DrawerProps extends Children {
  state: {
    top: boolean;
    right: boolean;
    bottom: boolean;
    left: boolean;
  };
  anchor: 'top' | 'right' | 'bottom' | 'left';
  onToggle: Function;
}

interface ContentProps {
  isFullWidth?: boolean;
}

const SwipeableDrawerStyled = styled(SwipeableDrawer)(({ theme }) => ({
  outlineOffset: '-2px', // Help out cursor context editor.
  '& .MuiDrawer-paper': {
    backgroundColor: theme.theme_component_drawer_background_color || theme.palette.primary.light,
    backgroundImage: theme.theme_component_drawer_background_image
      ? `url(https://${theme.theme_component_drawer_background_image}/)`
      : 'none',
    backgroundPosition: theme.theme_component_drawer_background_position || 'center',
    backgroundSize: theme.theme_component_drawer_background_size || 'cover',
    backgroundRepeat: theme.theme_component_drawer_background_repeat || 'no-repeat',
  },
})) as typeof SwipeableDrawer;

const Content = styled('div')<ContentProps>(({ theme, isFullWidth }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  width: isFullWidth ? 'auto' : theme.theme_component_drawer_width || 325,
}));

export const Drawer = (props: DrawerProps) => {
  const { state, anchor, onToggle, children } = props;

  // https://mui.com/api/swipeable-drawer
  // Take note; swipeAreaWidth can overlap the carousel arrow button.
  return (
    <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={onToggle(anchor, false)}>
      <SwipeableDrawerStyled
        // variant="persistent"
        anchor={anchor}
        open={state[anchor]}
        onClose={onToggle(anchor, false)}
        onOpen={onToggle(anchor, true)}
        swipeAreaWidth={10}
        {...useEditorHandlers('Drawer')}
      >
        <Content isFullWidth={anchor === 'top' || anchor === 'bottom'} role="presentation">
          {children}
        </Content>
      </SwipeableDrawerStyled>
    </ClickAwayListener>
  );
}